module.exports = __webpack_public_path__ + "static/media/application1.e8888cb2.png";